import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import CalendarSidePanel from './CalendarSidePanel';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { mounted, unmounted } from 'FRONTEND/reducers/sidePanelSlice';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

export default (element, store) => {
  store.dispatch(mounted());

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CalendarSidePanel rtcServerUrl={element.dataset.rtcServerUrl} />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    store.dispatch(unmounted());
    root.unmount();
  };
};
